// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"45b95000","252":"0786d2de","887":"4c1c5b56"}[chunkId] + ".chunk.css";
};